import React from 'react';
import withShipment from "../../withShipment";

import {
    CONFIRM_SHIPPED_SHIPMENT_IN_QUEUE,
    SHIPPED_SHIPMENT_QUEUE_HEADER_CELLS, ARCHIVE_SHIPPED_SHIPMENT_IN_QUEUE, RECONFIRM_SHIPPED_SHIPMENT
} from './constant';
import {TableCell, TableRow} from '@mui/material';
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import FeedbackBar from "../../components/feedbackBar/FeedbackBar";
import "./DashboardShippedShipmentQueue.css"
import ArchiveIcon from '@mui/icons-material/Archive';
import TaskAltIcon from '@mui/icons-material/TaskAlt';

import {
    updateShippedShipmentInQueue,
    addShippedShipmentToQueue,
    fetchShippedShipment,
    importShippedShipmentToQueue,
    listShippedShipmentInQueue, manualConfirmShippedShipment,
    resolveShippedShipment,
} from '../../redux/actions/dashboard';
import {shippedShipmentInQueueSelector} from '../../redux/selectors/dashboard';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ClearIcon from '@mui/icons-material/Clear';
import { userInfoSelector } from '../../redux/selectors/auth';
import Papa from 'papaparse';
import { clearStatus } from '../../redux/actions/global';
import { statusSelector } from '../../redux/selectors/global';
import FilterTagsBar from '../../components/shipments/FilterTagsBar';
import CustomTableHeader from '../../components/global/Table/CustomTableHeader';
import LocationSelectBox from '../../components/global/subcomponents/locationSelectBox/LocationSelectBox';
import {DEFAULT_SORT_BY_HEAD_CELL, FILTER,} from '../../components/purchaseOrders/constants';
import FilterIcon from '../../components/shipments/FilterIcon';
import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Slide,
    TablePagination,
    TextField,
    Paper
} from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import GlobalTableHead from '../../components/global/Table/GlobalTableHead';
import TableBody from '@material-ui/core/TableBody';
import { ASC, DESC } from '../../components/global/constants';
import ShippedShipmentQueueFiltersDialog from './ShippedShipmentQueueFiltersDialog';

import SearchableTable from '../../components/global/Search/SearchableTable';
import { DEFAULT_ROWS_PER_PAGE } from '../../components/returns/constants';
import { getTableSetting, saveTableSetting } from '../../redux/actions/account';
import { tableSettingSelector } from '../../redux/selectors/account';
import {
    PAGE_STATE,
    RESOLVE_SHIPMENT_DIALOG_TITLE,
    RESOLVE_SHIPMENT_SUCCESS_MESSAGE,
    RESOLVE_SHIPMENT_ERROR_MESSAGE
} from "./DashboardFinal/constants";
import ReplayIcon from '@mui/icons-material/Replay';

class DashboardShippedShipmentQueue extends SearchableTable {
    constructor(props) {
        super(props);
        this.state = {
            feedbackBarOpen: false,
            manualQueue: null,
            orderId: "",
            errorMessage: "",
            feedbackStatus: '',
            feedbackMessage: '',
            //table
            fromDate: this.getFromDate(),
            toDate: this.getToDate(),
            filtersMap: {},
            deletedTagsWithCookies: [],
            filterShipAddressId: this.props.userInfo.selectedLocationId,
            //search
            isSearch: false,
            searchValue: '',
            searchRows: 0,
            isFilterApplied: false,
            filtersMapBeforeOpenDialog: {},
            selectedStatus: [],
            dropdownAll: false,
            filtersOpen: false,
            order: DESC,
            orderBy: DEFAULT_SORT_BY_HEAD_CELL,
            page: 0,
            rowsPerPage: DEFAULT_ROWS_PER_PAGE,
            open: false,
            marketplaces: [],
            shipmentToUpdate: "",
            shipmentMarketplace:"",
            manualConfirm: false,
            confirmShipment: false,
            displayDialog: false,
            resolveOpen: false,
            resolveOrderId: "",
            resolveErrorMessage: ""
        }
    }

    async componentDidMount() {

        this.props.getTableSetting(this.props.userInfo.userId)

        if (this.props.registerImportHandler) {
            this.props.registerImportHandler(this.importQueueCSV);
        }

        if (this.props.registerAddHandler) {
            this.props.registerAddHandler(this.addShipmentQueue);
        }

        if (this.props.registerResolveHandler) {
            this.props.registerResolveHandler(this.resolveShipment);
        }

        let changeBack = false

        if (this.props.pageState === PAGE_STATE.ARCHIVED_SHIPMENT_QUEUE){
            await this.setState({
                selectedStatus: this.props.tableSetting?.archivedShipmentQueueFilterSetting,
            })
            await this.setState({
                selectedStatus: this.props.tableSetting?.shippedShipmentQueueFilterSetting,
            })
        }

        let localStorageName = this.props.pageState === PAGE_STATE.ARCHIVED_SHIPMENT_QUEUE ? "Archived Shipment Queue" : "Shipped Shipment Queue"
        let expiryKey = `${localStorageName}:expiry`
        let storage = JSON.parse(localStorage.getItem(localStorageName))

        if (storage) {
            const raw = localStorage.getItem(expiryKey)
            const expiry = raw ? parseInt(JSON.parse(raw)) : 0
            if (storage.fromDate !== null && storage.fromDate !== undefined) {
                if (expiry > Date.now()) {
                    this.setState({
                        fromDate: new Date(storage.fromDate),
                        toDate: storage.toDate ? new Date(storage.toDate) : this.getToDate(),
                        marketplaces: storage.marketplaces ?? [],
                        filtersMap: storage
                    }, () => this.closeFilters(true))
                } else {
                    changeBack = true
                }
            } else if (storage.toDate !== null && storage.toDate !== undefined) {
                if (expiry > Date.now()) {
                    this.setState({
                        fromDate: storage.fromDate ? new Date(storage.fromDate) : this.getFromDate(),
                        toDate: new Date(storage.toDate),
                        marketplaces: storage.marketplaces ?? [],
                        filtersMap: storage
                    }, () => this.closeFilters(true))
                } else {
                    changeBack = true
                }
            } else if (storage.marketplaces !== null && storage.marketplaces !== undefined) {
                if (expiry > Date.now()) {
                    this.setState({
                        fromDate: storage.fromDate ? new Date(storage.fromDate) : this.getFromDate(),
                        toDate: storage.toDate ? new Date(storage.toDate) : this.getToDate(),
                        marketplaces: storage.marketplaces ?? [],
                        filtersMap: storage
                    }, () => this.closeFilters(true))
                } else {
                    changeBack = true
                }
            }

            if (changeBack) {
                localStorage.removeItem(localStorageName)
                this.setState({
                    fromDate: this.getFromDate(),
                    toDate: this.getToDate(),
                    marketplaces: [],
                    filtersMap: {}
                })
            }
        } else {
            this.setState({
                fromDate: this.getFromDate(),
                toDate: this.getToDate(),
                marketplaces: [],
                filtersMap: {},
                deletedTagsWithCookies: [],
            }, () => this.refreshListShippedShipmentInQueue())
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.refreshQueue !== this.props.refreshQueue) {

            if (this.props.refreshQueue) {
                this.refreshListShippedShipmentInQueue()
            }
            this.props.setRefreshShippedShipmentQueue(false)
        }
        let changeBack = false

        if( prevProps?.pageState && prevProps?.pageState != this.props.pageState) {

            let localStorageName = this.props.pageState === PAGE_STATE.ARCHIVED_SHIPMENT_QUEUE ? "Archived Shipment Queue" : "Shipped Shipment Queue"
            const expiryKey = `${localStorageName}:expiry`
            let storage = JSON.parse(localStorage.getItem(localStorageName))

            if (storage) {

                const raw = localStorage.getItem(expiryKey)
                const expiry = raw ? parseInt(JSON.parse(raw)) : 0
                if (storage.fromDate !== null && storage.fromDate !== undefined) {
                    if (expiry > Date.now()) {
                        this.setState({
                            fromDate: storage.fromDate ? new Date(storage.fromDate) : this.getFromDate(),
                            toDate: storage.toDate ? new Date(storage.toDate) : this.getToDate(),
                            marketplaces: storage.marketplaces ?? [],
                            filtersMap: storage
                        }, () => this.closeFilters(true))
                    } else {
                        changeBack = true
                    }
                } else if (storage.toDate !== null && storage.toDate !== undefined) {
                    if (expiry > Date.now()) {
                        this.setState({
                            fromDate: storage.fromDate ? new Date(storage.fromDate) : this.getFromDate(),
                            toDate: storage.toDate ? new Date(storage.toDate) : this.getToDate(),
                            marketplaces: storage.marketplaces ?? [],
                            filtersMap: storage
                        }, () => this.closeFilters(true))
                    } else {
                        changeBack = true
                    }
                } else if (storage.marketplaces !== null && storage.marketplaces !== undefined) {
                    if (expiry > Date.now()) {
                        this.setState({
                            fromDate: storage.fromDate ? new Date(storage.fromDate) : this.getFromDate(),
                            toDate: storage.toDate ? new Date(storage.toDate) : this.getToDate(),
                            marketplaces: storage.marketplaces ?? [],
                            filtersMap: storage
                    }, () => this.closeFilters(true))
                    } else {
                        changeBack = true
                    }
                }

                if (changeBack) {
                    localStorage.removeItem(localStorageName)
                    this.setState({
                        fromDate: this.getFromDate(),
                        toDate: this.getToDate(),
                        marketplaces: [],
                        filtersMap: {}
                    })
                }
            }
            else {
                this.setState({
                    fromDate: this.getFromDate(),
                    toDate: this.getToDate(),
                    marketplaces: [],
                    filtersMap: {},
                    deletedTagsWithCookies: [],
                }, () => this.refreshListShippedShipmentInQueue())
            }
            if (this.props.pageState === PAGE_STATE.ARCHIVED_SHIPMENT_QUEUE){
                this.setState({selectedStatus: this.props.tableSetting?.archivedShipmentQueueFilterSetting})
            }else{
                this.setState({selectedStatus: this.props.tableSetting?.shippedShipmentQueueFilterSetting})
            }
        }


        if (this.props.status.statusText && prevProps.status.statusText !== this.props.status.statusText) {
            this.openFeedbackBar()
        }

        if (prevProps.tableSetting !== this.props.tableSetting) {
            if (this.props.pageState === PAGE_STATE.ARCHIVED_SHIPMENT_QUEUE){
                this.setState({selectedStatus: this.props.tableSetting?.archivedShipmentQueueFilterSetting})
            }else{
                this.setState({selectedStatus: this.props.tableSetting?.shippedShipmentQueueFilterSetting})
            }
        }
    }


    getFromDate = () => {
        const date = new Date()
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setDate(date.getDate())
        return date;
    }

    getToDate = () => {
        const date = new Date()
        date.setHours(23);
        date.setMinutes(59);
        date.setSeconds(59);
        return date;
    }

    isDefaultFromDate = (someDate) => {
        const defaultFromDate = this.getFromDate()
        return someDate.getDate() === defaultFromDate.getDate() &&
            someDate.getMonth() === defaultFromDate.getMonth() &&
            someDate.getFullYear() === defaultFromDate.getFullYear()
    }

    getNewDates = () => {
        let filter = {...this.state.filtersMap}
        let localStorageName = this.props.pageState === PAGE_STATE.ARCHIVED_SHIPMENT_QUEUE ? "Archived Shipment Queue" : "Shipped Shipment Queue"
        let storage = JSON.parse(localStorage?.getItem(localStorageName)) || {}

        if (storage.fromDate !== null && storage.fromDate !== undefined) {
            filter.fromDate = new Date(storage.fromDate)
        }
        if (storage.toDate !== null && storage.toDate !== undefined) {
            filter.toDate = new Date(storage.toDate)
        }
        if (storage.marketplaces !== null && storage.marketplaces !== undefined) {
            filter.marketplaces = storage.marketplaces
        }
        this.setState({
            fromDate: filter.fromDate ?? this.state.fromDate,
            toDate: filter.toDate ?? this.state.toDate,
            marketplaces: filter.marketplaces ?? this.state.marketplaces,
            filtersMap: filter
        })
    }

    isToday = (someDate) => {
        const today = new Date()
        return someDate.getDate() === today.getDate() &&
            someDate.getMonth() === today.getMonth() &&
            someDate.getFullYear() === today.getFullYear()
    }

    handleStatusChange = (event) => {
        const {checked, name} = event.target;
        const selectedStatus = this.state.selectedStatus || [];

        const updatedStatus = checked
            ? [...selectedStatus, name]
            : selectedStatus.filter(status => status !== name);

        this.setState({selectedStatus: updatedStatus}, () => {
            this.onFiltersInputChange(updatedStatus);
        });
    }

    handleRequestSort = (event, property) => {
        const isAsc = this.state.orderBy === property && this.state.order === ASC;
        this.setState({
            order: isAsc ? DESC : ASC,
            orderBy: property,
        });
    };

    showFiltersDialog = () => {
        const filtersMapClone = {...this.state.filtersMap};
        this.setState({
            filtersOpen: !this.state.filtersOpen,
            filtersMapBeforeOpenDialog: filtersMapClone
        });
    }

    closeFilters = (apply) => {
        this.setState({
            filtersOpen: false,
        });

        let filters = {}
        if (!apply) {
            filters = {...this.state.filtersMapBeforeOpenDialog}
            this.resetDateFilters(filters?.fromDate ?? this.getFromDate(), filters?.toDate ?? this.getToDate(), filters?.marketplaces ?? [])

            this.setState({
                filtersMap: filters
            })
        } else {
            let localStorageName = this.props.pageState === PAGE_STATE.ARCHIVED_SHIPMENT_QUEUE ? "Archived Shipment Queue" : "Shipped Shipment Queue"
            const expiryKey = `${localStorageName}:expiry`
            if (this.state.deletedTagsWithCookies.length > 0) {
                let storage = JSON.parse(localStorage.getItem(localStorageName)) || {}
                this.state.deletedTagsWithCookies.forEach((tagName) => {
                    delete storage[tagName]
                })
                localStorage.setItem(localStorageName, JSON.stringify(storage))
                if (Object.keys(storage).length === 0) localStorage.removeItem(localStorageName)
                this.setState({deletedTagsWithCookies: []})
            }
            filters = {...this.state.filtersMap}
            const expiry = new Date().setHours(23, 59, 59, 0);
            if (filters.fromDate !== null && filters.fromDate !== undefined) {
                let existing = localStorage.getItem(localStorageName)
                existing = existing ? JSON.parse(existing) : {};
                existing.fromDate = new Date(filters.fromDate).toISOString()
                localStorage.setItem(localStorageName, JSON.stringify(existing));
                localStorage.setItem(expiryKey, JSON.stringify(expiry))
            }
            if (filters.toDate !== null && filters.toDate !== undefined) {
                let existing = localStorage.getItem(localStorageName)
                existing = existing ? JSON.parse(existing) : {};
                existing.toDate = new Date(filters.toDate).toISOString()
                localStorage.setItem(localStorageName, JSON.stringify(existing));
                localStorage.setItem(expiryKey, JSON.stringify(expiry))
            }
            let existing = localStorage.getItem(localStorageName)
            existing = existing ? JSON.parse(existing) : {}
            if (filters.marketplaces !== null && filters.marketplaces !== undefined) {
                existing.marketplaces = filters.marketplaces
            } else {
                delete existing["marketplaces"]
            }
            localStorage.setItem(localStorageName, JSON.stringify(existing))
            localStorage.setItem(expiryKey, JSON.stringify(expiry))
            this.applyDateFilters(this.state.fromDate, this.state.toDate)
        }
    }

    clearFiltersMap = () => {
        this.setState({
            filtersMap: {},
            fromDate: this.getFromDate(),
            toDate: this.getToDate(),
            marketplaces: [],
        })
    }

    resetDateFilters = (fromDate, toDate, marketplaces) => {
        const coerceDate = (d) => (d instanceof Date ? d : (d ? new Date(d) : null));
        fromDate = coerceDate(fromDate);
        toDate   = coerceDate(toDate);
        let filtersMapClone = {...this.state.filtersMap}
        if (fromDate && !this.isDefaultFromDate(fromDate)) {
            filtersMapClone['fromDate'] = fromDate
        }
        if (toDate && !this.isToday(toDate)) {
            filtersMapClone['toDate'] = toDate
        }
        delete filtersMapClone['marketplaces']

        this.setState({
            fromDate: fromDate,
            toDate: toDate,
            filtersMap: filtersMapClone,
            marketplaces: marketplaces,
            deletedTagsWithCookies: [],
        })
    }

    onTagClickedWhenDialogueOpen = (event, tag) => {
        const filtersMap = {...this.state.filtersMap};
        let tagValue = filtersMap[tag]
        let deletedTagsWithCookies = this.state.deletedTagsWithCookies
        delete filtersMap[tag];
        let localStorageName = this.props.pageState === PAGE_STATE.ARCHIVED_SHIPMENT_QUEUE ? "Archived Shipment Queue" : "Shipped Shipment Queue"
        if (tag === 'fromDate') {
            let storage = JSON.parse(localStorage.getItem(localStorageName))
            if (storage) {
                if (storage.fromDate !== null && storage.fromDate !== undefined) {
                    if (new Date(storage.fromDate).getTime() === new Date(tagValue).getTime()) {
                        this.setState({deletedTagsWithCookies: [...deletedTagsWithCookies, "fromDate"]})
                    }
                }
            }
            this.setState({
                fromDate: this.getFromDate()
            })
        }
        if (tag === 'toDate') {
            let storage = JSON.parse(localStorage.getItem(localStorageName))
            if (storage) {
                if (storage.toDate !== null && storage.toDate !== undefined) {
                    if (new Date(storage.toDate).getTime() === new Date(tagValue).getTime()) {
                        this.setState({deletedTagsWithCookies: [...deletedTagsWithCookies, "toDate"]})
                    }
                }
            }
            this.setState({
                toDate: this.getToDate()
            })
        }

        if (tag === "marketplaces") {
            delete filtersMap["marketplaces"]
            this.setState({
                marketplaces: []
            })
        }

        this.setState({
            filtersMap: filtersMap,
        });
    }

    getDisplayed = (rows) => {
        if (!rows)
            return [];
        return [...rows.slice(this.state.page * this.state.rowsPerPage, (this.state.page + 1) * this.state.rowsPerPage)]
    }

    onTagClicked = (event, tag) => {
        const filtersMap = {...this.state.filtersMap};
        delete filtersMap[tag];
        let localStorageName = this.props.pageState === PAGE_STATE.ARCHIVED_SHIPMENT_QUEUE ? "Archived Shipment Queue" : "Shipped Shipment Queue"

        if (tag === 'fromDate') {
            let storage = JSON.parse(localStorage.getItem(localStorageName))
            delete storage.fromDate
            this.setState({
                fromDate: this.getFromDate()
            }, () => this.applyDateFilters(this.state.fromDate, this.state.toDate))
            localStorage.setItem(localStorageName, JSON.stringify(storage))
            if (JSON.stringify(storage) === JSON.stringify({})) localStorage.removeItem(localStorageName)
        }
        if (tag === 'toDate') {
            let storage = JSON.parse(localStorage.getItem(localStorageName))
            delete storage.toDate
            this.setState({
                toDate: this.getToDate()
            }, () => this.applyDateFilters(this.state.fromDate, this.state.toDate))
            localStorage.setItem(localStorageName, JSON.stringify(storage))
            if (JSON.stringify(storage) === JSON.stringify({})) localStorage.removeItem(localStorageName)
        }

        if (tag === "marketplaces") {
            let storage = JSON.parse(localStorage.getItem(localStorageName))
            delete storage.marketplaces
            this.setState({
                marketplaces: []
            })
            localStorage.setItem(localStorageName, JSON.stringify(storage))
            if (JSON.stringify(storage) === JSON.stringify({})) localStorage.removeItem(localStorageName)
        }

        this.setState({
            filtersMap: filtersMap
        })
    }

    onFiltersInputChange = (updatedStatusArray) => {
        const filtersMap = [...updatedStatusArray];

        this.saveUpdatedFilters(filtersMap);
    }

    getStatusFilteredShippedQueue = (data) => {
        if (this.state.selectedStatus) {
            return data.filter((item) => this.state.selectedStatus.includes(item.confirmStatus))
        }
        return [];
    }

    handleMarketplaceChange = (value) => {
        let filters = this.state.filtersMap
        if (value.length > 0) {
            filters["marketplaces"] = value
        }
        else {
            delete filters["marketplaces"]
        }
        this.setState({
            marketplaces: value,
            filtersMap: filters,
        })
    }

    onDateFiltersInputChange = (id, value) => {
        if (!value || isNaN(value.getTime())) {
            //User is still editing the date value, do not fetch orders
            this.setState({
                fromDate: id === "fromDate" ? value : this.state.fromDate,
                toDate: id === "toDate" ? value : this.state.toDate
            })
        } else {
            const date = value.toString()
            let filtersMapClone = {...this.state.filtersMap}
            if (id === 'fromDate' && !this.isDefaultFromDate(value) ||
                id === 'toDate' && !this.isToday(value)) {
                filtersMapClone[id] = date
            }
            this.setState({
                fromDate: id === "fromDate" ? value : this.state.fromDate,
                toDate: id === "toDate" ? value : this.state.toDate,
                filtersMap: filtersMapClone
            })
        }
    }

    applyDateFilters = (fromDate, toDate) => {
        this.props.listShippedShipmentInQueue({
            shipAddressId: this.props.userInfo.selectedLocationId,
            fromDate: fromDate,
            toDate: toDate,
            isArchived: this.props.pageState === PAGE_STATE.ARCHIVED_SHIPMENT_QUEUE
        })
    }

    saveUpdatedFilters = (filters) => {
        if (this.props.pageState === PAGE_STATE.ARCHIVED_SHIPMENT_QUEUE){
            this.props.saveTableSetting({
                userId: this.props.userInfo.userId,
                tableSetting: null,
                pageTitle: this.props.shipmentStatus,
                defaultTable: this.props.defaultTableDisplay,
                changeFilters: false,
                changeArchivedShipmentQueueFilters: true,
                archivedShipmentQueueFilters: filters
            })
        }else{
            this.props.saveTableSetting({
                userId: this.props.userInfo.userId,
                tableSetting: null,
                pageTitle: this.props.shipmentStatus,
                defaultTable: this.props.defaultTableDisplay,
                changeFilters: false,
                changeShippedShipmentQueueFilters: true,
                shippedShipmentQueueFilters: filters
            })
        }
    }

    handleLocationChange = (location) => {
        this.setState({
            filterShipAddressId: location.shipAddressId
        })
    }


    refreshListShippedShipmentInQueue = (location) => {

        this.props.listShippedShipmentInQueue({
            shipAddressId: location ? location.shipAddressId : this.props.userInfo.selectedLocationId,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            isArchived: this.props.pageState === PAGE_STATE.ARCHIVED_SHIPMENT_QUEUE
        })
        if (this.props.pageState !== PAGE_STATE.ARCHIVED_SHIPMENT_QUEUE){
            this.removeManualAddShipment()
        }
    }

    removeManualAddShipment = () => {
        this.setState({manualQueue: null, errorMessage: "", orderId: ""})
    }

    manualAddShipment = (row) => {
        this.props.addShippedShipmentToQueue({
            shipmentId: row.shipmentId,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            shipAddressId:  this.props.userInfo.selectedLocationId
        })
        this.removeManualAddShipment()
    }

    handleDialogClose = () => {
        this.setState({
            displayDialog: false,
            shipmentToUpdate: null,
            shipmentMarketplace:null,
            manualConfirm: false,
            confirmShipment: false
        });
    }

    handleConfirmShipment = (row) => {
        this.setState({
            shipmentToUpdate: row?.queueId,
            shipmentMarketplace: row?.marketplace,
            displayDialog: true,
            manualConfirm: false,
            confirmShipment: true
        })
    }

    handleManualConfirm = (row) => {
        this.setState({
            shipmentToUpdate: row?.queueId,
            shipmentMarketplace: row?.marketplace,
            displayDialog: true,
            manualConfirm: true,
            confirmShipment: false
        })
    }
    handleManualArvhice = (row) => {
        this.setState({
            shipmentToUpdate: row?.queueId,
            shipmentMarketplace: row?.marketplace,
            displayDialog: true,
            manualConfirm: false,
            confirmShipment: false
        })
    }

    handleConfirm = () => {
        if (this.state.confirmShipment){
            this.props.manualConfirmShippedShipment({
                queueId: this.state.shipmentToUpdate,
                fromDate: this.state.fromDate,
                toDate: this.state.toDate,
                shipAddressId:  this.props.userInfo.selectedLocationId
            });
        }
        else{
            this.props.updateShippedShipmentInQueue({
                queueId: this.state.shipmentToUpdate,
                fromDate: this.state.fromDate,
                toDate: this.state.toDate,
                isConfirm: this.state.manualConfirm,
                shipAddressId: this.props.userInfo.selectedLocationId
            });
        }
        this.handleDialogClose()
    }

    twoStepsConfirm = () => {
        const { displayDialog, shipmentToUpdate, shipmentMarketplace } = this.state;
        return (
            <Dialog
                open={displayDialog}
                onClose={this.handleDialogClose}
            >
                {this.state.confirmShipment?
                    <DialogContent dividers>
                        <p>Are you sure you want to retry confirming this shipment through {shipmentMarketplace}?
                            This action will attempt to update the tracking number of this order on {shipmentMarketplace}.</p>
                    </DialogContent>
                    :this.state.manualConfirm?
                    <DialogContent dividers>
                        <p>Has this shipment been confirmed manually on {shipmentMarketplace}?</p>
                    </DialogContent>
                :
                    <DialogContent dividers>
                        <p>Do you want to archive this shipment?</p>
                    </DialogContent>
                }

                <DialogActions>
                    <Button onClick={this.handleDialogClose} variant="contained">
                        No
                    </Button>
                    <Button
                        onClick={this.handleConfirm}
                        color="primary"
                        variant="contained"
                        disabled={!shipmentToUpdate}
                    >
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
        );
    };


    tableRow = (row, index, isManual = false) => {
        return (
            <TableRow key={index} className={isManual ? 'manual-row' : 'manual-row'}>
                <TableCell className="manualResolve">
                    {isManual && (
                        <>
                            <Tooltip title="Remove">
                                <IconButton onClick={this.removeManualAddShipment}>
                                    <ClearIcon fontSize="small" color="error"/>
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Confirm">
                                <IconButton onClick={() => this.manualAddShipment(row)}>
                                    <CheckCircleIcon fontSize="small" color="secondary"/>
                                </IconButton>
                            </Tooltip>
                        </>
                    )}
                </TableCell>

                <TableCell className="col-queue-cell-center-orderId">{row.orderId}</TableCell>
                <TableCell className="col-queue-cell-center-orderId">{row.trackingNumber}</TableCell>
                <TableCell className="col-queue-cell-center-name">{row?.carrierName}</TableCell>
                <TableCell className="col-queue-cell-center-name">{row?.carrierService}</TableCell>
                <TableCell className="col-queue-cell-center">{this.formatDate(row.shipDate)}</TableCell>
                <TableCell className="col-queue-cell-center-short">{row?.numOfPackages}</TableCell>
                <TableCell className="col-queue-cell-center-orderItems">{row?.orderItems}</TableCell>
                <TableCell className="col-queue-cell-center">{row.marketplace}</TableCell>
                <TableCell className="col-queue-cell-center">{row?.confirmStatus}</TableCell>
                <TableCell className="col-queue-cell-center">{row.responseCode}</TableCell>
                <TableCell className="col-queue-cell-center-long">{row?.responseReason}</TableCell>
                <TableCell className="col-queue-cell-center-short">{row?.retryCount}</TableCell>
                <TableCell className="col-queue-cell-center-short">{row?.confirmStatus == "Skipped"  ? "Yes" : "No"}</TableCell>
                <TableCell className="col-queue-cell-center-long">{row?.skipReason}</TableCell>
                <TableCell className="col-queue-cell-center-short">{row?.split ? "Yes" : "No"}</TableCell>
                <TableCell className="col-queue-cell-center-short">{row?.voided ? "Yes" : "No"}</TableCell>

                <TableCell className="manualResolve">
                    {!isManual && this.props.pageState !== PAGE_STATE.ARCHIVED_SHIPMENT_QUEUE && !row?.confirmed && !row?.voided ? (
                        <>
                            <Tooltip title={CONFIRM_SHIPPED_SHIPMENT_IN_QUEUE}>
                                <IconButton
                                    onClick={() => this.handleManualConfirm(row)}
                                >
                                    <TaskAltIcon fontSize="medium" />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title={RECONFIRM_SHIPPED_SHIPMENT + row.marketplace}>
                                <IconButton
                                    onClick={() => this.handleConfirmShipment(row)}
                                >
                                    <ReplayIcon fontSize="medium" />
                                </IconButton>
                            </Tooltip>
                        </>
                    ) : !isManual && this.props.pageState !== PAGE_STATE.ARCHIVED_SHIPMENT_QUEUE ? (
                            <Tooltip title={ARCHIVE_SHIPPED_SHIPMENT_IN_QUEUE}>
                                <IconButton
                                    onClick={() => this.handleManualArvhice(row)}
                                >
                                    <ArchiveIcon fontSize="medium" />
                                </IconButton>
                            </Tooltip>
                        ):
                        <IconButton style={{ visibility: "hidden" }}>
                            <ArchiveIcon fontSize="medium" />
                        </IconButton>
                    }
                </TableCell>
            </TableRow>
        );
    };


    searchStrings = (row) => {

        let searchStrings = [
            row?.orderId,
            row?.trackingNumber,
            row?.marketplace,
        ]
        return searchStrings.filter(Boolean);
    }


    formatDate = (date) => {
        if (date != null) {
            return date.includes("T") ? date.split("T")[0] : date
        }
        return ""
    }

    updateDashboardLocation = (location) => {
        this.props.updateLocationId(location)
        this.refreshListShippedShipmentInQueue(location)
    }

    addShipmentQueue = () => {
        this.setState({open: true, orderId: '', errorMessage: ''});
    }

    handleClose = () => {
        this.setState({open: false, errorMessage: ''});
    };

    handleInputChange = (e) => {
        const {name, value} = e.target;
        this.setState({[name]: value.trim()});
    }

    handleSubmit = () => {
        const {orderId} = this.state;
        if (!orderId) {
            return;
        }

        const callback = (success, response) => {
            if (!success) {
                this.setState({errorMessage: response});
            } else {
                this.setState({manualQueue: response, errorMessage: '', open: false});
            }
        };

        this.props.fetchShippedShipment({orderId}, callback);
    };

    resolveShipment = () => {
        this.setState({resolveOpen: true, resolveOrderId: '', resolveErrorMessage: ''});
    }

    handleResolveClose = () => {
        this.setState({resolveOpen: false, resolveErrorMessage: ''});
    };

    handleResolveSubmit = () => {
        const {resolveOrderId} = this.state;
        if (!resolveOrderId) {
            return;
        }

        const callback = (success, message) => {
            if (!success) {
                this.setState({resolveErrorMessage: message || RESOLVE_SHIPMENT_ERROR_MESSAGE});
                this.openFeedbackBar('error', message || RESOLVE_SHIPMENT_ERROR_MESSAGE);
            } else {
                this.setState({resolveErrorMessage: '', resolveOpen: false});
                this.openFeedbackBar('success', message || RESOLVE_SHIPMENT_SUCCESS_MESSAGE);
            }
        };

        this.props.resolveShippedShipment({
            orderId: resolveOrderId,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            shipAddressId: this.props.userInfo.selectedLocationId
        }, callback);
    };

    importQueueCSV = () => {
      // Create an input element dynamically for CSV file upload
      const fileInput = document.createElement('input');
      fileInput.type = 'file';
      fileInput.accept = '.csv';

      fileInput.onchange = (e) => {
          const file = e.target.files[0];
          if (file) {
              Papa.parse(file, {
                  header: true, // CSV file contains header
                  skipEmptyLines: true, // Skip empty rows
                  complete: (result) => {
                      // Normalize headers to lowercase without spaces
                      const normalizedData = result.data.map(row => {
                          const normalizedRow = {};
                          for (let key in row) {
                              const normalizedKey = key.replace(/\s+/g, '').toLowerCase();
                              normalizedRow[normalizedKey] = row[key];
                          }

                          return {
                               orderId: normalizedRow['orderid'] || ''};
                      });

                      const callback = (success, message, errorMessage) => {

                        if (!success) {
                          this.setState({ errorMessage: errorMessage })
                           this.openFeedbackBar('error', message)

                        } else {
                          this.setState({  errorMessage: '' })
                          this.openFeedbackBar('success', message)
                        }
                      };

                      this.props.importShippedShipmentToQueue({
                          rows: normalizedData,
                          shipAddressId:  this.props.userInfo.selectedLocationId,
                          fromDate: this.state.fromDate,
                          toDate: this.state.toDate,
                      },callback);
                  },
                  error: (error) => {
                      console.error('Error parsing CSV:', error);
                  }
              });
          }
      };
      fileInput.click();
  }

    openFeedbackBar = (status, message) => {
        this.setState({feedbackStatus: status, feedbackMessage: message, feedbackBarOpen: true})
    }

    closeFeedbackBar = () => {
        this.setState({feedbackBarOpen: false, feedbackStatus: '', feedbackMessage: ''}, () => {
            this.props.clearStatus()
        })
    }

    applyOverviewFilters = (rows) => {
        if (this.state.selectedStatus) {
            rows = rows.filter((item) => this.state.selectedStatus.includes(item.confirmStatus))
        }

        return rows;
    }

    filterBySearch = (rows) => {
        const {searchValue} = this.state;
        if (!searchValue) return rows;

        return rows.filter(row => {
            const orderId = row.orderId || '';
            const trackingNumber = row.trackingNumber || '';

            return (
                orderId.toLowerCase().includes(searchValue.toLowerCase()) ||
                trackingNumber.toLowerCase().includes(searchValue.toLowerCase())
            );
        });
    }

    handleChangeRowsPerPage = (event) => {
        this.setRowsPerPage(event.target.value)
        this.setPage(0)
    };

    setPage = (page) => {
        this.setState({
            page: page
        })
    }

    handleChangePage = (event, newPage) => {
        this.setPage(newPage)
    };

    setRowsPerPage = (rowsPerPage) => {
        this.setState({
            rowsPerPage: rowsPerPage
        })
    }

    onSearchValueChange = (event) => {
        const value = event.target.value.trimStart();
        this.setState({
            isSearch: value.length > 0,
            searchValue: value,
            searchText: value,
            page: 0
        });
    };

    render() {

        const {manualQueue, errorMessage, orderId, open} = this.state
        const tableRows = manualQueue ? [manualQueue, ...this.props.shippedShipmentInQueue] : this.props.shippedShipmentInQueue

        return (
            <div className="root">
                <Dialog open={open} onClose={this.handleClose} maxWidth="sm" fullWidth>
                    <DialogTitle>Add shipment to queue</DialogTitle>
                    <DialogContent>
                        <div className="manual-queue-form"
                             style={{display: 'flex', flexDirection: 'column', gap: '1rem', marginTop: 8}}>

                            <TextField
                                className='queue-text-field'
                                variant="outlined"
                                name="orderId"
                                value={orderId}
                                size="small"
                                onChange={this.handleInputChange}
                                label="Order ID"
                                InputLabelProps={{shrink: true}}
                            />
                            {errorMessage && <div style={{color: 'red', fontSize: 13}}>{errorMessage}</div>}
                        </div>
                    </DialogContent>
                    <DialogActions style={{marginBottom: '16px', marginRight: '16px'}}>
                        <Button onClick={this.handleClose}>Cancel</Button>
                        <Button onClick={this.handleSubmit} disabled={!this.state.orderId} variant="contained"
                                color="primary">
                            Submit
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={this.state.resolveOpen} onClose={this.handleResolveClose} maxWidth="sm" fullWidth>
                    <DialogTitle>{RESOLVE_SHIPMENT_DIALOG_TITLE}</DialogTitle>
                    <DialogContent>
                        <div className="manual-queue-form"
                             style={{display: 'flex', flexDirection: 'column', gap: '1rem', marginTop: 8}}>

                            <TextField
                                className='queue-text-field'
                                variant="outlined"
                                name="resolveOrderId"
                                value={this.state.resolveOrderId}
                                size="small"
                                onChange={this.handleInputChange}
                                label="Order ID"
                                InputLabelProps={{shrink: true}}
                            />
                            {this.state.resolveErrorMessage &&
                                <div style={{color: 'red', fontSize: 13}}>{this.state.resolveErrorMessage}</div>}
                        </div>
                    </DialogContent>
                    <DialogActions style={{marginBottom: '16px', marginRight: '16px'}}>
                        <Button onClick={this.handleResolveClose}>Cancel</Button>
                        <Button onClick={this.handleResolveSubmit} disabled={!this.state.resolveOrderId}
                                variant="contained" color="primary">
                            Submit
                        </Button>
                    </DialogActions>
                </Dialog>

                {this.twoStepsConfirm()}

                {!open &&
                    errorMessage && <div className="error-text">{errorMessage}</div>
                }

                <FeedbackBar
                    open={this.state.feedbackBarOpen}
                    handleClose={this.closeFeedbackBar}
                    severity={this.state.feedbackStatus}
                    message={this.state.feedbackMessage}
                />

                <Paper className="paper">
                    <>
                        <FilterTagsBar
                            filtersMap={this.state.filtersMap}
                            onClick={this.state.filtersOpen ? this.onTagClickedWhenDialogueOpen : this.onTagClicked}
                        />
                        <CustomTableHeader
                            isPurchaseOrderTable={true}
                            searchText={this.state.searchValue}
                            onSearchValueChange={this.onSearchValueChange}
                            location={
                                <LocationSelectBox
                                    selectedLocationId={this.state.filterShipAddressId}
                                    updateCallback={this.updateDashboardLocation}
                                />
                            }
                            filterIcon={
                                <Tooltip title={FILTER} style={{paddingTop: 10}}>
                                    <IconButton className="filterButton" size='small' aria-label={FILTER}
                                                onClick={this.showFiltersDialog}>
                                        <FilterIcon/>
                                    </IconButton>
                                </Tooltip>
                            }
                            showFilters={this.state.filtersOpen}
                            filtersComponent={
                                <Slide in={this.state.filtersOpen} mountOnEnter unmountOnExit timeout={300}>
                                    <ShippedShipmentQueueFiltersDialog
                                        isOpen={this.state.filtersOpen}
                                        onOpen={this.showFiltersDialog}
                                        onChange={this.onFiltersInputChange}
                                        clearFilters={this.clearFiltersMap}
                                        onClose={this.closeFilters}
                                        fromDate={this.state.fromDate}
                                        toDate={this.state.toDate}
                                        handleDateChange={this.onDateFiltersInputChange}
                                        handleMarketplaceChange={this.handleMarketplaceChange}
                                        marketplaceOptions={["Amazon.ca", "Amazon.com", "Walmart.ca", "Walmart.com"]}
                                        marketplaces={this.state.marketplaces}
                                    />
                                </Slide>}
                            customFilterField={
                                <>
                                    <div className="filters">
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={this.state.selectedStatus?.includes('Pending') || false}
                                                    onChange={this.handleStatusChange}
                                                    name="Pending"
                                                    style={{color: '#acd685'}}
                                                />}
                                            label="Pending"
                                        />
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={this.state.selectedStatus?.includes('In Progress') || false}
                                                    onChange={this.handleStatusChange}
                                                    name="In Progress"
                                                    style={{color: '#acd685'}}
                                                />}
                                            label="In Progress"
                                        />
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={this.state.selectedStatus?.includes('Completed') || false}
                                                    onChange={this.handleStatusChange}
                                                    name="Completed"
                                                    style={{color: '#acd685'}}
                                                />}
                                            label="Completed"
                                        />
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={this.state.selectedStatus?.includes('Skipped') || false}
                                                    onChange={this.handleStatusChange}
                                                    name="Skipped"
                                                    style={{color: '#acd685'}}
                                                />}
                                            label="Skipped"
                                        />
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={this.state.selectedStatus?.includes('Error') || false}
                                                          onChange={this.handleStatusChange}
                                                          name="Error"
                                                          style={{color: '#acd685'}}
                                                />}
                                            label="Error"
                                        />
                                    </div>
                                </>
                            }
                            pagination={
                                <TablePagination
                                    className="table-pagination"
                                    labelRowsPerPage="Shipped queue per page"
                                    rowsPerPageOptions={[5, 25, 50, 100, {
                                        value: this.props.shippedShipmentInQueue?.length || 0,
                                        label: "All"
                                    }]}
                                    count={
                                        this.props.shippedShipmentInQueue
                                            ? this.filterBySearch(
                                                this.applyOverviewFilters(
                                                    this.props.shippedShipmentInQueue.filter(row =>
                                                        !this.state.marketplaces?.length || this.state.marketplaces.includes(row.marketplace)
                                                    )
                                                )
                                            )?.length
                                            : 0
                                    }
                                    rowsPerPage={this.state.rowsPerPage}
                                    page={this.state.page}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                />
                            }
                        />

                        <TableContainer>
                            <Table
                                aria-labelledby="tableTitle"
                                size={'medium'}
                            >
                                <GlobalTableHead
                                    isShippingQueue={true}
                                    headCells={SHIPPED_SHIPMENT_QUEUE_HEADER_CELLS}
                                    order={this.state.order}
                                    orderBy={this.state.orderBy}
                                    onRequestSort={this.handleRequestSort}
                                    rowCount={tableRows?.length}
                                />

                                <TableBody>
                                    {this.getDisplayed(this.stableSort(
                                        this.filterBySearch(
                                            (
                                                (manualQueue
                                                        ? [manualQueue, ...(this.props.shippedShipmentInQueue || [])]
                                                        : (this.props.shippedShipmentInQueue || [])
                                                )
                                                    ?.filter(row => row && this.getStatusFilteredShippedQueue([row])?.length > 0)
                                                    ?.filter(row =>
                                                        !this.state.marketplaces?.length || this.state.marketplaces?.includes(row.marketplace)
                                                    ) || []
                                            )
                                        ),
                                        this.getComparator?.(this.state.order, this.state.orderBy) || (() => 0)
                                    ))?.map?.((row, index) => this.tableRow(row, index, row === manualQueue)) || null}
                                </TableBody>

                            </Table>
                        </TableContainer>
                    </>
                </Paper>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    status: statusSelector(state),
    userInfo: userInfoSelector(state),
    shippedShipmentInQueue: shippedShipmentInQueueSelector(state),
    tableSetting: tableSettingSelector(state),

})

const actionCreators = {
    clearStatus,
    listShippedShipmentInQueue,
    fetchShippedShipment,
    addShippedShipmentToQueue,
    updateShippedShipmentInQueue,
    manualConfirmShippedShipment,
    importShippedShipmentToQueue,
    resolveShippedShipment,
    saveTableSetting,
    getTableSetting,

}

export default withShipment({
    mapStateToProps,
    actionCreators
}, DashboardShippedShipmentQueue);